import React from 'react';
import DialogForm from 'mrf/view/DialogForm';
import { Col, Grid } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';
import { useDialogFormSelector } from 'mrf/redux/ReduxHelper';
import ButtonIcon from '../ButtonIcon';
import { EditIcon } from 'styles/components/Icons';

export default function EditUserProfileDialogForm({
    label,
    field,
    initField,
    ...props
}) {
    const context = useDialogFormSelector({
        resource: `${field}Form`,
        initForm: () => ({ [field]: initField }),
    });

    return (
        <>
            <ButtonIcon
                size={5}
                icon={EditIcon}
                tooltip='Edit'
                onClick={context.open}
            />
            <DialogForm
                title={`Edit ${label}`}
                method='PUT'
                context={context}
                width='1/2'
                {...props}
            >
                <Grid>
                    <Col size={12}>
                        <TextField label={label} field={field} />
                    </Col>
                </Grid>
            </DialogForm>
        </>
    );
}
